import React, { useState } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { auth, db } from '../../../firebase';
import { Card, CardBody, Col, Container, Input, Label, Row, Button, Form, FormFeedback, Alert, Spinner } from 'reactstrap';

import { Link, useNavigate } from "react-router-dom";
import withRouter from "../../../Components/Common/withRouter";
import * as Yup from "yup";
import { useFormik } from "formik";
import { logoLight } from '../../../utils/config';

// import { loginUser } from '../../../rtk/slices/crm-slices/auth/authSlice';


import authBG from '../../../assets/images/Home-Banner-11.png'
import AuthSlider from '../AuthenticationInner/authCarousel';
import { signInWithCustomToken } from 'firebase/auth';


const CrmLogin = (props) => {

    const [passwordShow, setPasswordShow] = useState(false);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            account: "",
            password: "",
        },
        validationSchema: Yup.object({
            account: Yup.string().required("Please Enter Your account"),
            password: Yup.string().required("Please Enter Your Password"),
        }),
        onSubmit: async (values, { setSubmitting, setErrors }) => {
            try {
                // 1. Login to get the Firebase custom token from your backend
                const response = await fetch("https://trader-firebase-backend.onrender.com/api/login", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        account: values.account,
                        password: values.password,
                    }),
                });

                const data = await response.json();

                if (!response.ok) {
                    setErrors({ password: data.error || "Login failed" });
                    return;
                }

                const firebaseToken = data.token;
                const userData = data.user; 

                // 2. Use Firebase Auth to sign in with the custom token
                const userCredential = await signInWithCustomToken(auth, firebaseToken);

                const user = userCredential.user;

                // Optional: fetch Firestore user document if needed
                // Or you can attach claims in token and read from `userCredential.user`

                // 3. Save auth data
                localStorage.setItem("token", firebaseToken);
                localStorage.setItem("user", JSON.stringify({
                    uid: user.uid,
                    ...userData, // ✅ store all fields from backend
                }));

                // 4. Navigate to dashboard
                props.router.navigate("/dashboard");
            } catch (error) {
                console.error("Login error:", error);
                setErrors({ password: "Login failed. Please try again." });
            } finally {
                setSubmitting(false);
            }
        }



    });

    document.title = "SignIn | Trading Dashboard";
    return (
        <React.Fragment>

            <div className="auth-page-content d-flex justify-content-center align-items-center"
                style={{

                    minHeight: '100vh',
                    backgroundImage: `url(${authBG})`,
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover'
                }}
            >
                <Container>



                    <Row className="justify-content-between align-items-center">
                        <Col md={5} className='p-0 d-md-block d-none'>

                            <AuthSlider />
                        </Col>
                        <Col md={6}>
                            <Card className="py-5 border" style={{ background: '#080808d6', backdropFilter: 'blur(3px)' }}>
                                <CardBody className="p-4">
                                    <div className="text-center mt-2">
                                        {/* <h5 className="text-primary">Welcome Back !</h5> */}
                                        <Link to="/dashboard" className="d-block mb-1">
                                            <img src={logoLight} alt="" height="18" />
                                        </Link>
                                        <h4 className='mb-0 fw-bold'>Sign in to access your account</h4>
                                    </div>

                                    <div className="p-2 mt-4">
                                        <Form
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                validation.handleSubmit();
                                                return false;
                                            }}
                                            action="#">

                                            <div className="mb-3">
                                                <Label htmlFor="account" className="form-label">Account</Label>
                                                <Input
                                                    name="account"
                                                    className="form-control p-3"
                                                    placeholder="Enter account number"
                                                    type="text"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.account || ""}
                                                    invalid={
                                                        validation.touched.account && validation.errors.account ? true : false
                                                    }
                                                />
                                                {validation.touched.account && validation.errors.account ? (
                                                    <FormFeedback type="invalid">{validation.errors.account}</FormFeedback>
                                                ) : null}
                                            </div>

                                            <div className="mb-3">
                                                <div className="float-end">
                                                    <Link to="https://backend.pfxinvestments.com/" className="text-muted">Forgot password?</Link>
                                                </div>
                                                <Label className="form-label" htmlFor="password-input">Password</Label>
                                                <div className="position-relative auth-pass-inputgroup mb-3">
                                                    <Input
                                                        name="password"
                                                        value={validation.values.password || ""}
                                                        type={passwordShow ? "text" : "password"}
                                                        className="form-control pe-5 p-3"
                                                        placeholder="Enter Password"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        invalid={
                                                            validation.touched.password && validation.errors.password ? true : false
                                                        }
                                                    />
                                                    {validation.touched.password && validation.errors.password ? (
                                                        <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                                                    ) : null}
                                                    <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted h-100" type="button" id="password-addon" onClick={() => setPasswordShow(!passwordShow)}><i className="ri-eye-fill align-middle"></i></button>
                                                </div>
                                            </div>


                                            <div className="mt-4">
                                                <Button color="warning"
                                                    disabled={validation.isSubmitting}
                                                    block
                                                    type="submit">
                                                    {validation.isSubmitting ? <Spinner size="sm" /> : "Login"}
                                                </Button>
                                            </div>

                                        </Form>
                                    </div>
                                </CardBody>
                            </Card>

                            {/* <div className="mt-4 text-center">
                                <p className="mb-0">Don't have an account ? <Link to="/register" className="fw-bold text-warning text-decoration-underline"> Signup </Link> </p>
                            </div> */}

                        </Col>
                    </Row>
                </Container>
            </div>
            {/* </ParticlesAuth> */}
        </React.Fragment>
    );
};

export default withRouter(CrmLogin);
